<template>
  <div class="g-container">
    <!-- <cmp-header></cmp-header> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <div
      class="footer"
      style="position:absolute;bottom:0;line-height:40px;background:gray;width:100%;"
    >测试底部</div>-->
  </div>
</template>

<script>
import cmpHeader from '@cmp/header/index'
export default {
  components: {
    cmpHeader
  }
}
</script>